import type { FunnelTemplate } from "@/lib/funnel-planner/engine";

export const franchiseMultiLocationTemplate: FunnelTemplate = {
  id: "franchise-multi-location",
  serviceLine: "franchise",
  recommendedBands: ["growth", "enterprise"],
  pdfAccentColor: "#16a34a",
  defaultTrafficChannels: [
    { id: "google_organic", label: "Google Organic",           monthlyVisitors: 500, acquisitionType: "organic" },
    { id: "google_ads",     label: "Google Ads",               monthlyVisitors: 300, acquisitionType: "cpc", cpc: 2.5 },
    { id: "facebook_ads",   label: "Facebook / Instagram Ads", monthlyVisitors: 150, acquisitionType: "cpc", cpc: 1.8 },
    { id: "direct_mail",    label: "Direct Mail",              monthlyVisitors: 50,  acquisitionType: "organic" },
  ],
  defaultStages: [
    { id: "awareness",  conversionRate: 100, isEditable: false, stageType: "blog-post" },
    { id: "local-serp", conversionRate: 4,   isEditable: true,  stageType: "landing-page" },
    { id: "landing",    conversionRate: 12,  isEditable: true,  stageType: "opt-in-page" },
    { id: "lead",       conversionRate: 6,   isEditable: true,  stageType: "discovery-call" },
    { id: "qualified",  conversionRate: 30,  isEditable: true,  stageType: "application" },
    { id: "onboarded",  conversionRate: 55,  isEditable: true,  stageType: "retainer-close" },
  ],
};
